<template lang="html">
  <div class="container-fluid p-5">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">Promotion Ticket List</div>

          <!-- Filter -->
          <div class="col-md-4 mt-4">
            <label>Status</label>
            <select class="form-control" v-model="filter.status">
              <option value="">Select Status</option>
              <option :value="true">Active</option>
              <option :value="false">Inactive</option>
            </select>

            <div class="mt-3">
              <button @click="search()" class="btn btn-primary mr-1 fbutton">
                <i class="fas fa-search"></i> Search
              </button>
            </div>
          </div>

          <div class="card-body">
            <div class="table-responsive mt-4">
              <table class="common-table">
                <thead>
                  <tr>
                    <th
                      v-for="(value, key) in columns"
                      :key="key"
                      style="cursor: pointer"
                      @click="sortBy(key)"
                    >
                      {{ value }}
                      <!-- <span v-if="filter.sortKey === key">
                        <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                        <i v-else class="fas fa-sort-down"></i>
                      </span> -->
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(data, index) in dataList" :key="data.id">
                    <td>{{ data.id }}</td>
                    <td>{{ data.ticket_name }}</td>
                    <td>{{ data.type }}</td>
                    <td>{{ data.value_type }}</td>
                    <td>{{ data.value }}</td>
                    <td>{{ data.expired_at ? data.expired_at : "---" }}</td>

                    <td>
                      <span v-if="data.status" class="badge badge-success"
                        >Active</span
                      >
                      <span v-else class="badge badge-danger">Inactive</span>
                    </td>

                    <td>
                      <button
                        class="btn btn-option text-primary"
                        @click="editData(data)"
                      >
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        class="btn btn-option text-danger"
                        v-b-modal.deleteModal
                        @click="deleteData(data)"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>

                  <tr v-if="dataList.length === 0">
                    <td colspan="8" class="text-center">Empty List</td>
                  </tr>
                </tbody>
              </table>

              <!-- Pagination -->
              <div class="table-pagination-minimal">
                <div class="table-pagination-row">
                  <div
                    v-if="dataList.length > 0"
                    class="table-info-minimal left-align"
                  >
                    Showing {{ metaData.from }} to {{ metaData.to }} of
                    {{ metaData.total }} entries
                  </div>

                  <nav class="pagination-minimal">
                    <ul>
                      <li :class="{ disabled: metaData.current_page === 1 }">
                        <button
                          @click.prevent="next(metaData.current_page - 1)"
                        >
                          <i class="fas fa-angle-left"></i>
                        </button>
                      </li>

                      <li
                        v-for="page in metaData.last_page"
                        :key="page"
                        :class="{ active: metaData.current_page === page }"
                        v-if="
                          Math.abs(page - metaData.current_page) < 3 ||
                          page == 1 ||
                          page == metaData.last_page
                        "
                      >
                        <button @click.prevent="next(page)">{{ page }}</button>
                      </li>

                      <li
                        :class="{
                          disabled:
                            metaData.current_page === metaData.last_page,
                        }"
                      >
                        <button
                          @click.prevent="next(metaData.current_page + 1)"
                        >
                          <i class="fas fa-angle-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            <!-- Delete Modal -->
            <b-modal
              id="deleteModal"
              ref="deleteModal"
              title="Delete"
              hide-footer
            >
              <p>Are you sure to delete?</p>
              <p class="text-danger">{{ alert }}</p>
              <b-button block class="btn-danger mt-3" @click="deleteItem()"
                >Delete</b-button
              >
            </b-modal>

            <!-- Floating Add Button -->
            <router-link class="float" to="promotion-create">
              <i class="fa fa-plus my-float" style="padding: 37%"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "PromotionList",
  metaInfo: { title: "Promotion List" },
  components: { Loading },

  data() {
    return {
      isLoading: false,
      fullPage: true,
      alert: "",
      id: "",
      dataList: [],
      columns: {
        id: "ID",
        ticket_name: "Ticket Name",
        type: "Type",
        value_type: "Value Type",
        value: "Value",
        expired_at: "Expired At",
        status: "Status"
      },
      filter: {
        page: 1,
        per_page:10,
        orderBy: "asc",
        sortKey: "id",
        status: true,
      },
      metaData: {
                 last_page: null,
                 current_page: 1,
                 from: null,
                 to: null,
                 total: null,
                 prev_page_url: null
             }
    };
  },

  methods: {
    ...mapActions({
      promotionListAction: "promotionListAction",
      promotionDeleteAction: "promotionDeleteAction",
    }),

    sortBy(column) {
      this.filter.sortKey = column;
      this.filter.orderBy = this.filter.orderBy === "asc" ? "desc" : "asc";
      this.fetchData();
    },

    search() {
      this.filter.page = 1;
      this.fetchData();
    },

    async fetchData() {
      this.isLoading = true;

      await this.promotionListAction(this.filter).then((res) => {
        if (res.success === true) {
          this.dataList = res.data.data;
          this.metaData = res.data.meta;
          this.metaData.last_page = res.data.meta.lastPage
          this.metaData.current_page = res.data.meta.currentPage
          this.metaData.prev_page_url = res.data.meta.prevPageUrl
          this.metaData.from = res.data.meta.from
          this.metaData.to = res.data.meta.to
          this.metaData.total = res.data.meta.total
        }
        this.isLoading = false;
      });
    },

    next(page) {
      this.filter.page = page;
      this.fetchData();
    },

    editData(data) {
      this.$router.replace({
        path: "promotion-edit",
        query: { id: data.id },
      });
    },

    deleteData(data) {
      this.id = data.id;
      this.alert = "";
    },

    async deleteItem() {
      this.isLoading = true;
      await this.promotionDeleteAction({ id: this.id }).then((res) => {
        if (!res.success) {
          this.alert = res.message;
          return;
        }
        this.$refs["deleteModal"].hide();
        this.fetchData();
      }).catch((err) => {
        this.isLoading = false;
        this.alert = err.message;
      })
      this.isLoading = false;
    }
  },

  mounted() {
    this.fetchData();
  }
};
</script>
